/**
 * A `Field`-based view which displays the attributes of a given model in a read-only fashion.
 * ## Fields
 * Name | Description
 * --- | ---
 * model | The model associated with the view.
 * fields | The array of `Field` models displayed by the view.
 * @module app/views/DetailView
 */
import Backbone from "backbone";
import _ from "underscore";
import $ from "jquery";
import fieldViewFactory from "core/views/Field/FieldViewFactory";
export default Backbone.View.extend({
  tagName: "div",
  className: "form-horizontal",

  /**
   * Initializes the controlƒ.h
   * @param  {object} options The options hash.
   * @param {mixed} options.model The model to associate with the view.
   * @param {Array} options.fields The array of `Field` models to display in the view.
   */
  initialize: function (options) {
    this.options = options;

    this.model = this.options.model;
    this.fields = this.options.fields;
  },

  template: _.template(
    '<div class="form-group search-group"><label class="control-label"<%if(description){%> data-toggle="tooltip" title="<%= description %>"<%}%>><%= label %></label><div class="col-sm-12 form-control-static no-padding form-value"></div></div>'
  ),

  render: function () {
    this.$el.children().remove();
    _.each(
      this.fields,
      function (field) {
        var row = $(
          this.template({
            label: field.get("label"),
            description: field.get("description"),
          })
        );
        var view = fieldViewFactory.getViewer(field, this.model);

        view.render();
        row.find(".form-control-static").append(view.$el);
        this.$el.append(row);
      },
      this
    );
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/DetailView.js
// module id = 105
// module chunks = 1